import { format } from 'date-fns';
import { AlertContainer, AlertContent, IconBox } from './alert';
import AlertHeader from './alert-header';
import AlertLocation from './alert-location';
import { styled } from '@mui/material';
import { useHistory } from '../../../hooks/use-history-intercept';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

const AlertIconBox = styled(IconBox)({
    backgroundColor: '#B5D1F9'
});

const AlertIcon = styled(TrackChangesIcon)({
    color: '#2C5A9C',
    width: 16
});

interface FormAlertProps {
    date: Date;
    location?: string;
    patientId: string;
    email: string;
    name: string;
    onRemove?: () => void;
}

export default function NewEmailFromPatientAlert({ date, name, email, location, patientId, onRemove }: FormAlertProps) {
    const history = useHistory();

    return (
        <AlertContainer onClick={() => history.push(`/contacts/contacts/${patientId}`)}>
            <AlertHeader
                icon={
                    <AlertIconBox>
                        <AlertIcon />
                    </AlertIconBox>
                }
                title='Campaigns'
                date={format(date, 'hh:mm a')}
                onClose={onRemove}
            />
            <AlertContent>
                {name} just provided a new email address. Please add it to your practice software - {email}
            </AlertContent>
            {!!location && <AlertLocation>{location}</AlertLocation>}
        </AlertContainer>
    );
}
